"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A container to use within a $dyn.controls.Pivot.
         */
        var PivotItem = /** @class */ (function (_super) {
            __extends(PivotItem, _super);
            function PivotItem(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                if (!$dyn.isObservable(_this.PanelStyle)) {
                    _this.PanelStyle = $dyn.observable(_this.PanelStyle);
                }
                return _this;
            }
            PivotItem.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.isActive = $dyn.computed(function () {
                    var activeName = _this._parent.activeItemName();
                    return activeName === _this.Name;
                });
                this.LayoutColumns = $dyn.ui.columnsProperty($dyn.layout.Columns.balanced, this);
                this.LayoutWidth = $dyn.ui.tabWidth(this);
                this.LayoutHeight = $dyn.ui.tabHeight(this);
                // if this is a DetailsMaster or Transaction we need to watch the ActiveItemName change
                // to handle the view selector move
                if (this.Root &&
                    ($dyn.value(this.Root.Style) === $dyn.forms.Styles.DetailsFormMaster ||
                        $dyn.value(this.Root.Style) === $dyn.forms.Styles.DetailsFormTransaction)) {
                    $dyn.observe(this.isActive, function (value) {
                        if (value) {
                            _this.Root.changeDetailsViewElement(_this._parent, _this.Name);
                        }
                    });
                }
            };
            /**
             * @returns The page header element for this Pivot Item.
             */
            PivotItem.prototype.getHeader = function () {
                var pivotItemHeader;
                var pivotItem = $(this.element);
                if (pivotItem) {
                    var pivotHeader = pivotItem.siblings(".pivot-header");
                    if (pivotHeader.length) {
                        pivotItemHeader = pivotHeader.children().find('[data-dyn-mappedTab="' + $dyn.value(this.Name) + '"]')[0];
                    }
                    var dropListHeader = pivotItem.siblings(".pivot-dropListMenu");
                    if (dropListHeader.length) {
                        pivotItemHeader = dropListHeader.children(".dynamicsButton")[0];
                    }
                }
                return pivotItemHeader;
            };
            /**
             * @returns The page header element for this Pivot Item.
             */
            PivotItem.prototype.getPersonalizableTarget = function () {
                return this.getHeader();
            };
            /**
             * @returns The JQuery of the page header element for this Pivot Item.
             */
            PivotItem.prototype.getExpandoPersonalizationFocusTarget = function () {
                return $(this.getHeader());
            };
            /**
             * @returns if control is available for expando personalization feature
             */
            PivotItem.prototype.isControlAvailableForExpando = function () {
                return true;
            };
            /**
             * @returns The PivotItem's parent.
             */
            PivotItem.prototype.getParent = function () {
                return this._parent;
            };
            PivotItem.prototype.getTaskGuideParams = function (options) {
                var pivotItemHeader = this.getHeader();
                $.extend(options, {
                    adjustMethod: "flip",
                    at: $dyn.layout.qTipPosition.bottomCenter,
                    my: $dyn.layout.qTipPosition.topCenter,
                    target: pivotItemHeader ? $(pivotItemHeader) : $(this.element),
                });
                return options;
            };
            PivotItem.prototype.getPersonalizationElements = function () {
                var personalizationElements = [this.element];
                var pivotItemHeader = this.getHeader();
                if (pivotItemHeader) {
                    // If we have a header add it at the beginning of the personalization elements so
                    // it is used for any qtips.
                    personalizationElements.unshift(pivotItemHeader);
                }
                return personalizationElements;
            };
            /**
             * @param parent This pivot item's parent element (the pivot itself).
             */
            PivotItem.prototype.animateWidthResize = function (parent) {
                var _this = this;
                $dyn.observe($dyn.clientBusy, function (isBusy) {
                    if (!isBusy) {
                        var children_1 = _this.Children();
                        if (children_1.length === 1 && children_1[0].TypeName === "Part") {
                            var el_1 = $(parent.element);
                            var margin = parseInt($dyn.ui.theme.get().margin, 10);
                            var ow = $(_this.element).outerWidth();
                            var tabWidth = el_1.hasClass("verticalTab") ? $(_this.getHeader()).outerWidth() + margin : 0;
                            el_1.animate({ width: tabWidth + ow + "px" }, $dyn.ui.motionTiming.basic, function () {
                                el_1.css("width", "");
                            });
                        }
                    }
                    else {
                        return true;
                    }
                    return false;
                });
            };
            /**
             * Activates a tab and scrolls it into view.
             */
            PivotItem.prototype.Activate = function (event) {
                if (!$dyn.value(this.isActive)) {
                    this.ActivateTabInternal();
                    this.scrollIntoView();
                    $dyn.callFunction(this.ActivateTab, this, []);
                }
                if ($dyn.ax.personalizationUtil) {
                    $dyn.ax.personalizationUtil.forceUpdateFormPersonalizationData();
                }
            };
            PivotItem.prototype.FocusHeader = function () {
                var headerElement = this.getHeader();
                if (headerElement) {
                    headerElement.focus();
                }
            };
            /** @internal */
            PivotItem.prototype.focusCallback = function () {
                // This means that no control was found to focus inside of this container
                // we will set focus to the header element and the container will be the active control.
                var containerHeaderElement = this.getHeader ? this.getHeader() : undefined;
                if (containerHeaderElement) {
                    $dyn.util.focusElement(containerHeaderElement);
                }
            };
            /**
             * Scrolls the Pivot Item into view (ie, if it's hidden because it's in overflow).
             */
            PivotItem.prototype.scrollIntoView = function () {
                var containerHeaderElement = this.getHeader ? this.getHeader() : undefined;
                var el = $(this.element.parentElement);
                var horizontalTab = el.hasClass("pivot-list-hasOverflow") ? true : false;
                if (containerHeaderElement !== undefined && horizontalTab) {
                    var headerOffset = containerHeaderElement.offsetLeft;
                    var headerWidth = containerHeaderElement.offsetWidth;
                    var tabList = containerHeaderElement.parentElement;
                    var tabListWidth = tabList.offsetWidth;
                    var contentWidth = tabList.scrollWidth;
                    var maxScroll = contentWidth - tabListWidth - 1;
                    var scrollLeft = tabList.scrollLeft;
                    var nextButton = tabList.parentElement.querySelector(".pivot-listOverflowNext");
                    var prevButton = tabList.parentElement.querySelector(".pivot-listOverflowPrevious");
                    var carouselButtonAdjust = $(nextButton).outerWidth() * 2;
                    if (headerOffset < scrollLeft + carouselButtonAdjust) {
                        var scroll_1 = headerOffset - carouselButtonAdjust;
                        $(tabList).scrollLeft(scroll_1);
                        if ((headerOffset - carouselButtonAdjust) === 0) {
                            prevButton.setAttribute("disabled", "true");
                        }
                        else {
                            prevButton.removeAttribute("disabled");
                        }
                    }
                    else if ((headerOffset + headerWidth) > (tabListWidth + scrollLeft)) {
                        var scroll_2 = scrollLeft - ((tabListWidth + scrollLeft) - (headerOffset + headerWidth)) + carouselButtonAdjust;
                        $(tabList).scrollLeft(scroll_2);
                        if (scroll_2 >= maxScroll - carouselButtonAdjust) {
                            nextButton.setAttribute("disabled", "true");
                        }
                        else {
                            nextButton.removeAttribute("disabled");
                        }
                    }
                }
            };
            PivotItem.prototype.ActivateTabInternal = function () {
                var tabContainerContext = $dyn.context($(this.element).closest(".pivot-container")[0]);
                if ($dyn.value(tabContainerContext.Style) === $dyn.ui.TabStyle.vertical && $dyn.value(tabContainerContext.Width) === $dyn.layout.Size.content) {
                    var tabContainerElement = $(tabContainerContext.element);
                    // We retain the current size so we can show an animation, animateWidthResize will reset this to auto.
                    tabContainerElement.css("width", tabContainerElement.css("width"));
                    tabContainerContext.activeItemName(this.Name);
                    this.animateWidthResize(tabContainerContext);
                }
                else {
                    tabContainerContext.activeItemName(this.Name);
                }
            };
            return PivotItem;
        }($dyn.ui.Container));
        controls.PivotItem = PivotItem;
        PivotItem.prototype.PanelStyle = $dyn.ui.autoValue;
        PivotItem.prototype.ActivateTab = null;
        PivotItem.prototype.Label = "";
        PivotItem.prototype.Width = $dyn.layout.Size.available;
        PivotItem.prototype.Height = $dyn.layout.Size.available;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=PivotItem.js.map
